import { CircularProgress, Link } from '@mui/material'
import { downloadFileName } from 'controllers/documents/DocumentsController'
import { useState } from 'react'

interface DownloadLinkProps {
  disabled?: boolean
  fileName?: string
}

export default function DownloadLink({ disabled, fileName }: DownloadLinkProps) {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  return (
    <Link
      onClick={() => {
        if (disabled || isSubmitting || !fileName) return

        setIsSubmitting(true)
        downloadFileName(fileName).finally(() => setIsSubmitting(false))
      }}
      sx={{ cursor: disabled ? 'not-allowed' : isSubmitting ? 'wait' : 'pointer' }}
    >
      {isSubmitting ? <CircularProgress size={16} /> : 'Download'}
    </Link>
  )
}
